import Vue from "vue"
import ElementUI from "element-ui"
import "element-ui/lib/theme-chalk/index.css"

import Dialog from "./dialog"

Vue.use(ElementUI, { size: "mini" })
Vue.use(Dialog)
